import { __require as s } from "./main10.js";
var e, t;
function d() {
  if (t) return e;
  t = 1;
  var n = s();
  function i(r, a, f) {
    var u = r == null ? void 0 : n(r, a);
    return u === void 0 ? f : u;
  }
  return e = i, e;
}
export {
  d as __require
};
